import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4">
      <div className="w-full max-w-md border border-neutral-800 bg-neutral-900 p-8 text-center" data-testid="payment-cancel-page">
        <AlertCircle className="w-12 h-12 mx-auto text-amber-500" />
        <div className="display text-3xl mt-4">Payment cancelled</div>
        <p className="text-neutral-400 text-sm mt-2">No charge was made. You can try again anytime.</p>
        <Link to="/dashboard" className="mt-6 inline-block px-6 py-3 bg-amber-500 text-neutral-950 font-bold uppercase tracking-widest text-xs hover:bg-amber-400 transition-colors">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
